import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import { ServerConnectionService } from './server-connection.service';
import {zona} from '../models/zona';
import {HttpClientService} from "./http-client.service";

@Injectable({
  providedIn: 'root'
})
export class ZonaService {

  constructor(private http: HttpClientService) { }

  public getAll() {
    return this.http.get('/zona/getall');
  }

  public getByIdPlano(planoID: string) {
    let params = new HttpParams().set("planoID",planoID);
    return this.http.getWithParams('/zona/getbyidplano', params);
  }

  public getByIdProyecto(proyectoID: string) {
    let params = new HttpParams().set("proyectoID",proyectoID);
    return this.http.getWithParams('/zona/getbyidproyecto', params);
  }

  public getByIdProyectoDTO(proyectoID: string) {
    let params = new HttpParams().set("proyectoID",proyectoID);
    return this.http.getWithParams('/zona/getbyidproyectodto', params);
  }

  public getByIDProyectoPaginated(idProyecto: string, page) {
    let params = new HttpParams().set("idProyecto",idProyecto).set("page",page);
    return this.http.getWithParams('/zona/getbyidproyectopaginated', params);
  }

  public getCountByIDProyecto(idProyecto: string) {
    let params = new HttpParams().set("idProyecto",idProyecto);
    return this.http.getWithParams('/zona/getcountbyidproyecto', params);
  }

  public add(zona: zona) {
    return this.http.post('/zona/add', zona);
  }

  public update(zona: zona) {
    return this.http.post('/zona/update', zona);
  }

  public delete(id: string) {
    return this.http.delete('/zona/delete/' + id);
  }

  public sendOrden(json: any) {
    this.http.post('/zona/sendorden', JSON.stringify(json)).subscribe(result => {
      console.log(result);
    });
  }

  public sendAllZonas() {
    return this.http.post('/zona/sendallzonas', "").subscribe(result => {
      console.log(result);
    });
  }

}
